import {Avatar, Box, Stack, Typography} from '@mui/material';
import {FC, ReactNode} from 'react';
import {IUserAccount} from '../../shared/types/user-account.types';
import {getFullName} from '../../shared/helpers/getFullName';

interface IManagerBusinessCard {
  manager: IUserAccount;
  changeManager?: ReactNode;
}

const boxStyle = {
  minWidth: '252px',
  maxWidth: '100%',
  padding: '10px 8px',
  borderRadius: '6px',
  border: '1px solid #3DC99B',
  height: 'fit-content',
};

const fullNameStyle = {
  color: '#0F9FFF',
};

const additionalTextStyle = {
  color: '#25222D',
  fontSize: '12px',
  opacity: 0.7,
  wordBreak: 'break-word',
};

const ManagerBusinessCard: FC<IManagerBusinessCard> = ({manager, changeManager}) => {
  return (
    <Box sx={boxStyle}>
      <Stack direction="row" sx={{alignItems: 'center'}} spacing={2}>
        <Avatar />
        <Stack direction="column">
          <Typography sx={fullNameStyle} variant="subtitle1">
            {getFullName(manager)}
          </Typography>
          <Typography sx={additionalTextStyle}>{manager.phoneNumber}</Typography>
          <Typography sx={additionalTextStyle}>{manager.email}</Typography>
        </Stack>
      </Stack>
      {changeManager && (
        <Stack direction="row" justifyContent="flex-end" mt={2}>
          {changeManager}
        </Stack>
      )}
    </Box>
  );
};

export default ManagerBusinessCard;
